import React,{useEffect,useState} from 'react';
import AmbassadorHeader from '../../components/common/AmbassadorHeader';
import Logo from '../../components/common/Logo';
import SidebarMenu from '../../components/ambassador/SidebarMenu';
import {Accordion,AccordionBody} from '../../components/common/Accordion';
import {useNavigate,useLocation} from 'react-router-dom';
import {changePassword} from '../../actions/AmbassadorActions';
import swal from 'sweetalert';
import InMobileSideMenu from '../../components/ambassador/InMobileSideMenu';


function AmbassadorChangePassword(){
    const navigate = useNavigate()
    const location=useLocation();
    const[detail,setDetail]=useState(undefined)
    useEffect(() => {
        sessionStorage.getItem('ambDetail') ?  navigate('/ambassador/change-password') : navigate('/ambassador/login');

        if(location&& location.state!==null){
            const {detail}=location.state
            setDetail(detail)
      
        }
  },[location.state]);
    const currentUser = JSON.parse(sessionStorage.getItem('ambDetail'));
    const [oldPassword, setOldPassword] = useState({ value:'', error: '', isRequired: false });
    const [password,setPassword]=useState({name:'password',value:'',error:'',isRequired:true})
    const [confirmPassword,setConfirmPassword]=useState({name:'confirmPassword',value:'',error:'',isRequired:true})
    
    const handleConfirmPasswordChange=(e)=>{
        let value = e.target.value
        value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
        setConfirmPassword({...confirmPassword,value:value,error:''})  
    }
    const validation = () => {
        var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let formIsValid = true
        
        // Old Passowrd
        if (!oldPassword.value) {
            formIsValid = false
            let msg = "Please enter current password"
            setOldPassword({...oldPassword,error:msg})
        }
      
        // Passowrd
        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({...password,error:msg})
        }
        if(password.value.length <= 7){
            formIsValid = false
            let msg = "Password must contain at least 8 characters"
            setPassword({...password,error:msg})
        }
        // if(password.value && !(passRegex.test(password.value))){
        //     formIsValid = false
        //     let msg = "Alpha Numeric Field with Minimum 8 Charcter Length and Required atleast 1 Uppercase, 1 Lower case, 1 special character, 1 number and 1 alphabet"
        //     setPassword({...password,error:msg})
        // }
    
        // confirm pass
        if (!confirmPassword.value){
            formIsValid = false
            let msg = "Please confirm you password"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        if (confirmPassword.value!==password.value){
            formIsValid = false
            let msg = "Password is not matching"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        
        if(formIsValid){
            setOldPassword({...oldPassword,error:''})
            setPassword({...password,error:''})
            setConfirmPassword({...confirmPassword,error:''})

        }
    
        return formIsValid;
    
    }


    const onSubmit = (e) => {
        e.preventDefault();
        if(validation()){
            const data = {
                id : currentUser.id,
                oldPassword : oldPassword.value,
                newPassword : password.value
    
            }
            e.preventDefault();
            changePassword(data).then(res => {
                if (res.status) {
                    swal(res.message,'','success');
                    sessionStorage.clear()
                    navigate('/ambassador/login');
                }
                else{
                    swal(res.message,'','error')
                }
            })
            .catch(err => {
                console.log(err)
            })
        }
       

    }
    
    return(
        <>
  

        <div className='mainAmb_wrapper'>
      {/* Sidebar */}
      <div className={`sidebar_contain`}>
       
            <Logo alt="Logo"/>
            <div className='sidebar_menu_contains'>
               <SidebarMenu detail={detail}/>
            </div>
         
      </div>

      <div className='mobile_sideMenuWrap d-block d-lg-none'>
         <InMobileSideMenu detail={detail}/>
      </div>
      
      <div className='main_contentAmb'>
      {/* Header */}
      <div className='headerAmb_contain'>
      <AmbassadorHeader/>
      </div>
      <div className='amb_content'>
         <div className='container'>
            <div className='row  mt-3'>
                <div className='col-lg-12'>
                    <h2 className='h5 fw-bold'>Change Password</h2>
                </div>
            </div>
            <div className='row  mt-3'>
               <div className='col-lg-12'>
                  <div className='card shadow-sm'>
                     <div className='card-header'>
                        <div className='card-title'>Change Password</div>
                     </div>
                     <div className='card-body px-4'>
                        <div className='row'>
                        <div className='col-lg-12'>
                        <form  onSubmit={onSubmit}>
                            <div className="row">
                                <div className="col-lg-6 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type="password" 
                                        className="form-control" 
                                        placeholder="Enter Code" 
                                        value={oldPassword.value}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
                                            setOldPassword({...oldPassword,value:value, error:''})}
                                        }
                                        />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label>Current Password</label>
                                    </div>
                                    {oldPassword.error.length>0 && <div className='invalidFeedback'>{oldPassword.error}</div>}

                                </div>
                                <div className='w-100'></div>
                                <div className="col-lg-6 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type="password" 
                                        className="form-control" 
                                        placeholder="Enter Code" 
                                        value={password.value}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
                                            setPassword({...password,value:value, error:''})}
                                    }
                                         />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label>New Password</label>
                                    </div>
                                    {password.error.length>0 && <div className='invalidFeedback'>{password.error}</div>}

                                </div>
                                <div className='w-100'></div>
                                <div className="col-lg-6 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type="password" 
                                        className="form-control"
                                        placeholder="Enter Code" 
                                        value={confirmPassword.value}
                                        onChange={handleConfirmPasswordChange}
                                        />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label  htmlFor="floatingInput">Confirm Password</label>
                                    </div>
                                    {confirmPassword.error.length>0 && <div className='invalidFeedback'>{confirmPassword.error}</div>}

                                </div>
                                <div className='w-100'></div>
                                <div className="col-lg-12">
                                    <input type="submit" className="btn btn-primary" value="Update" />
                                </div>

                            </div>
                            </form>
                        </div>
                        </div>
                        
                
                     </div>
                  </div>
               </div>
            </div>
         </div>
      
      </div>
      
      </div>


      </div>


        </>
    );
}

export default AmbassadorChangePassword;